import React from "react"
import {graphql, Link, useStaticQuery} from "gatsby"
import SwiperCore, {Autoplay} from 'swiper'
import {Swiper, SwiperSlide} from "swiper/react"
import Img from 'gatsby-image'

import PQLogo from '../assets/images/pq-full-logo.png'
import Facebook from '../assets/icons/facebook-icon-white.png'
import Twitter from '../assets/icons/twitter-icon-white.png'
import Youtube from '../assets/icons/youtube-icon-white.png'

const Footer = () => {

  const {wpMenu} = useStaticQuery(graphql`
    {
      wpMenu(slug: {eq: "footer-menu"}) {
        menuItems {
          nodes {
            label
            url
            order
            parentId
            id
            databaseId
            connectedNode {
              node {
                uri
              }
            }
            childItems {
              nodes {
                label
                title
                url
                id
                connectedNode {
                  node {
                    uri
                  }
                }
              }
            }
          }
        }
        footer {
          fieldGroupName
          applyNow
          logos {
            fieldGroupName
            logo {
              altText
              localFile {
                childImageSharp {
                  fixed(width: 150) {
                    ...GatsbyImageSharpFixed_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const childMenuItems = [];
  const parentMenuItems = [];

  wpMenu?.menuItems?.nodes.forEach(menuItem => {
    if (!menuItem.parentId) {
      parentMenuItems.push(menuItem)
    } else {
      childMenuItems.push(menuItem)
    }
  });

  const footerLogos = wpMenu?.footer?.logos

  SwiperCore.use([Autoplay])

  return (
    <footer id="site-footer" role="contentinfo">
      <div className="footer-logos">
        <Swiper
          breakpoints={{
            768: {
              slidesPerView: 4
            },
            1100: {
              slidesPerView: 6
            },
            1500: {
              slidesPerView: 8
            }
          }}
          slidesPerView={2}
          speed={750}
          loop={true}
          spaceBetween={50}
          autoplay={{delay: 3200}}>
          {footerLogos ? footerLogos.map((logo, index) => {
            return (
              <SwiperSlide key={`logo-${index}`}>
                <div className="logo-wrapper">
                  <Img fixed={logo.logo?.localFile?.childImageSharp?.fixed}/>
                </div>
              </SwiperSlide>
            )
          }) : null}
        </Swiper>
      </div>
      <div className="footer-top">
        <div className="footer-main">
          <div className="footer-info">
            <div className="site-logo">
              <Link
                to="/"
              >
                <img alt="" src={PQLogo}/>
              </Link>
            </div>
            <div className="footer-contact-wrapper">
              <a href="tel:+18089375806">808-937-5806</a>
              <span>301 Kalanianaole Ave., Hilo, HI 96720</span>
            </div>
          </div>
          <div className="footer-nav-wrapper">
            {parentMenuItems?.map((parent, index) => {
              return (
                <div className="footer-col" key={`nav-${index}`}>
                  <li
                    className="menu-header"
                  >
                    {parent.label}
                  </li>
                  {childMenuItems.map((child, i) => {
                    if (child.parentId === parent.id) {
                      const isExternal = child.url && (child.url.startsWith('http://') || child.url.startsWith('https://'));
                      return (
                        <li key={i + child.id}>
                          {isExternal ? (
                            <a href={child.url}>{child.label}</a>
                          ) : (
                            <Link to={child.connectedNode ? child.connectedNode.node.uri : child.url}>
                              {child.label}
                            </Link>
                          )}
                        </li>
                      );
                    }
                  })}

                </div>
              )
            })}
          </div>
          <div className="social-wrapper">
            {wpMenu?.footer?.applyNow && (
              <a className="btn button-outline" href={wpMenu?.footer?.applyNow}>Apply Now</a>
            )}
            <div className="footer-social">
              <a href="https://www.facebook.com/pacificquesthawaii/" target="_blank" rel="noreferrer">
                <img alt="" src={Facebook}/>
              </a>
              <a href="https://twitter.com/pqhawaii/" target="_blank" rel="noreferrer">
                <img alt="" src={Twitter}/>
              </a>
              <a href="https://www.youtube.com/channel/UClxFTPgLAgSWuDRHkpLQCbw" target="_blank" rel="noreferrer">
                <img alt="" src={Youtube}/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright"></div>
    </footer>
  )
}

export default Footer
